<div class="lp-card">
  <h3 class="lp-card__title">Lesson Activities</h3>
  <p class="lp-muted">Short activities shown between this lesson's notes. Students must attempt one to continue,
    but do not need to get it right.</p>

  <div class="game-list" *ngIf="!editing">
    <div class="game-list__row" *ngFor="let game of games">
      <div>
        <span class="game-list__type">{{game.gameType === 'match' ? 'Match' : game.gameType === 'sequence' ? 'Sequence' : 'Flashcards'}}</span>
        <span class="game-list__title">{{game.title || '(untitled)'}}</span>
        <span class="lp-muted">— page {{game.page}}</span>
      </div>
      <div class="game-list__actions">
        <button type="button" class="btn btn--sm m-0" (click)="editGame(game)">Edit</button>
        <button type="button" class="btn btn--sm btn--danger m-0" (click)="confirmDelete(game)">Delete</button>
      </div>
    </div>
    <p class="lp-muted mb-0" *ngIf="games.length === 0">No activities yet for this lesson.</p>

    <div class="game-list__add">
      <button type="button" class="btn btn--sm m-0" (click)="newGame('match')"><i class="fas fa-plus"></i> Add match activity</button>
      <button type="button" class="btn btn--sm m-0" (click)="newGame('sequence')"><i class="fas fa-plus"></i> Add sequence activity</button>
      <button type="button" class="btn btn--sm m-0" (click)="newGame('flashcard')"><i class="fas fa-plus"></i> Add flashcard activity</button>
    </div>
  </div>

  <form *ngIf="editing" (ngSubmit)="save()" class="game-form">
    <label class="game-form__label">Title
      <input type="text" name="title" [(ngModel)]="editing.title" placeholder="e.g. Match the term to its definition">
    </label>
    <label class="game-form__label">Page (position among this lesson's notes)
      <input type="number" name="page" min="1" [(ngModel)]="editing.page">
    </label>

    <ng-container *ngIf="editing.gameType === 'match'">
      <div class="game-form__row" *ngFor="let pair of editing.pairs; let i = index">
        <input type="text" [(ngModel)]="pair.term" [name]="'term'+i" placeholder="Term">
        <input type="text" [(ngModel)]="pair.definition" [name]="'def'+i" placeholder="Definition">
        <button type="button" class="game-form__rm" (click)="removePair(i)" title="Remove">&times;</button>
      </div>
      <button type="button" class="game-form__addrow" (click)="addPair()">+ Add pair</button>
    </ng-container>

    <ng-container *ngIf="editing.gameType === 'sequence'">
      <div class="game-form__row" *ngFor="let step of editing.steps; let i = index">
        <span class="game-form__idx">{{i + 1}}</span>
        <input type="text" [(ngModel)]="step.text" [name]="'step'+i" placeholder="Step">
        <button type="button" class="game-form__rm" (click)="removeStep(i)" title="Remove">&times;</button>
      </div>
      <button type="button" class="game-form__addrow" (click)="addStep()">+ Add step</button>
      <p class="lp-muted">Steps are saved in the order shown above — that order is the correct answer.</p>
    </ng-container>

    <ng-container *ngIf="editing.gameType === 'flashcard'">
      <div class="game-form__row" *ngFor="let card of editing.cards; let i = index">
        <input type="text" [(ngModel)]="card.front" [name]="'front'+i" placeholder="Front (question)">
        <input type="text" [(ngModel)]="card.back" [name]="'back'+i" placeholder="Back (answer)">
        <button type="button" class="game-form__rm" (click)="removeCard(i)" title="Remove">&times;</button>
      </div>
      <button type="button" class="game-form__addrow" (click)="addCard()">+ Add card</button>
      <p class="lp-muted">Students must flip and confirm every card before they can finish.</p>
    </ng-container>

    <div class="game-form__actions">
      <button type="submit" class="btn m-0" [disabled]="saving">Save activity</button>
      <button type="button" class="btn btn--outline m-0" (click)="cancelEdit()">Cancel</button>
    </div>
  </form>

  <div class="mt-4">
    <button type="button" class="btn btn--sm btn--outline m-0" (click)="goback()">&larr; Back to lesson</button>
  </div>
</div>

<div class="modal fade" [class.show]="!!gameToDelete" [style.display]="gameToDelete ? 'block' : 'none'" *ngIf="gameToDelete">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Activity</h3>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete "{{gameToDelete.title || 'this activity'}}"?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="button" class="btn btn--danger m-0" (click)="deleteGame()">Delete</button>
          <button type="button" class="btn m-0" (click)="gameToDelete = null">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
